/**
 * Zero-dependency className joiner for the MUI → Tailwind migration.
 *
 * Replaces the repeated `[...].filter(Boolean).join(' ')` pattern in Tailwind
 * components. Accepts strings, falsy values (dropped), and arrays.
 *
 * We intentionally do NOT use `clsx`/`tailwind-merge` — no new libraries during
 * the migration (see CLAUDE.md). There is no class-conflict resolution here;
 * order your classes so the intended one wins, or keep the last-write via
 * plain string concatenation as `Button.tsx` does.
 */
type ClassValue = string | number | null | false | undefined | ClassValue[];

export const cn = (...classes: ClassValue[]): string =>
    classes
        .flat(Infinity as 1)
        .filter((c): c is string | number => Boolean(c))
        .join(' ');

export default cn;
